function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#33B6DC",
  d: "M21.759 10.84c-.462.41-1.191.41-1.653 0l-8.555-7.833c-.365-.362-.608-.362-.972-.024-1.872 1.711-8.58 7.858-8.58 7.858-.462.41-1.19.41-1.653 0-.461-.41-.461-1.085 0-1.519L10.238.307a1.264 1.264 0 0 1 1.653 0l9.868 9.04a.98.98 0 0 1 0 1.494zM4.72 10.697c.656 0 1.167.53 1.167 1.157v4.893s0 .94.948.94h8.458c.948 0 .948-.94.948-.94v-4.893c0-.65.534-1.157 1.166-1.157.632 0 1.167.53 1.167 1.157v6.99c0 .65-.535 1.157-1.167 1.157H4.721c-.656 0-1.166-.53-1.166-1.157v-6.99c0-.627.534-1.157 1.166-1.157z"
});

var SvgHomeDetailed = function SvgHomeDetailed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeDetailed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homeDetailed.60203957.svg";
export { ForwardRef as ReactComponent };